import '../components/home/home.css';
import '../styles/design-tokens.css';
import PageLayout from '../components/home/PageLayout';
import { Link } from 'react-router-dom';

/* ── 9 service items from the production page (3 rows × 3) ── */
const SERVICES = [
  { icon: 'fa-file-text-o', title: 'Documentation' },
  { icon: 'fa-university',  title: 'University short listing by experts' },
  { icon: 'fa-globe',       title: 'Assistance in applications' },
  { icon: 'fa-money',       title: 'Cost of sending documents for first three universities' },
  { icon: 'fa-user',        title: 'Profile upgrading' },
  { icon: 'fa-rocket',      title: 'Guidance for loan, visa and accommodation' },
  { icon: 'fa-book',        title: 'Access to library for preparing examinations like GRE, GMAT, IELTS, TOEFL' },
  { icon: 'fa-plane',       title: 'Travel insurance' },
  { icon: 'fa-search',      title: 'Assistance in finding part time jobs' },
];

/* ── Alternating image/text content rows from the production page ── */
const CONTENT_ROWS = [
  {
    img:      '/images/wqe.jpg',
    imgAlt:   'IELTS TOEFL Training',
    imgLeft:  true,
    heading:  'IELTS/ TOEFL Training',
    body:     'English is the world language, and still many of us are lacking there. IELTS/ TOEFL is mandatory for application with minimum required score. We provide training, including plenty of practice material and test series.',
  },
  {
    img:      '/images/ww.jpg',
    imgAlt:   'Interview Preparations',
    imgLeft:  false,
    heading:  'Interview Preparations',
    body:     'Make yourself ready for the professional world. Looking for someone to guide you for your upcoming interviews? Are you afraid of your English dialect and want to work on it in Very short time? Are you a fresher and have never faced an interview before? With our one to one guidance and session you can get ready for your requirement very shortly and face this professional world with confidence.',
  },
  {
    img:      '/images/cv.png',
    imgAlt:   'Making CV Resume Biodata',
    imgLeft:  true,
    heading:  'Making CV, Resume, Biodata',
    body:     'There is a huge difference between Biodata, Resume and CV. Each of them means different and in this world of full of professionalism you can not ignore that. We draft your CV/ Resume/Biodata along with additional documents. Get your professional identity in your hand and let the world wonder about your detailing in your CV/Resume/Biodata!',
  },
];

export default function StudyAbroadPage() {
  return (
    <PageLayout
      title="STUDY ABROAD CONSULTANCY & LANGUAGE ACADEMY"
      breadcrumb="Study Abroad Consultancy"
    >
      {/* ── Intro Section ── */}
      <div className="sa-inner-section sa-inner-section-white">
        <div className="sa-container">
          <div className="sa-inner-section-header">
            <h2 className="sa-sa-intro-heading">Study Abroad Consultancy</h2>
            <hr className="sa-sa-full-divider" />
            <h4 className="sa-sa-intro-sub">Are you planning to study abroad?</h4>
          </div>
          <p className="sa-text-intro sa-sa-intro-para">
            Each and every step in this process is important and needs to be taken care of cautiously
            and we believe in helping you do so. For each University shortlisted with your choice and
            consultation, we provide separate documents (LOM, LOR, SOP etc), accommodation, different
            formats of CV, scholarships (if applicable), drafting review/research papers, assistance
            with internships, jobs in Germany and many more countries. We assure, once you come to us
            you can get ready to board!
          </p>
        </div>
      </div>

      {/* ── 9 Service Icon Cards ── */}
      <div className="sa-inner-section sa-inner-section-white">
        <div className="sa-container">
          <div className="sa-sa-services-icon-grid">
            {SERVICES.map(s => (
              <div key={s.title} className="sa-sa-service-icon-card">
                <div className="sa-sa-service-icon-circle">
                  <i className={`fa ${s.icon}`} aria-hidden="true" />
                </div>
                <h3 className="sa-sa-service-icon-title">{s.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Alternating Image / Text Content Rows ── */}
      <div className="sa-inner-section sa-inner-section-white">
        <div className="sa-container">
          {CONTENT_ROWS.map(row => (
            <div key={row.heading} className="sa-sa-content-row">
              {row.imgLeft ? (
                <>
                  <div className="sa-sa-content-row-img">
                    <img src={row.img} alt={row.imgAlt} />
                  </div>
                  <div className="sa-sa-content-row-text">
                    <h3>{row.heading}</h3>
                    <p>{row.body}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="sa-sa-content-row-text">
                    <h3>{row.heading}</h3>
                    <p>{row.body}</p>
                  </div>
                  <div className="sa-sa-content-row-img">
                    <img src={row.img} alt={row.imgAlt} />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* ── CTA Band ── */}
      {/* <div className="sa-inner-cta-band">
        <div className="sa-container sa-sa-cta-inner">
          <h3>Ready to start your journey abroad?</h3>
          <p>Contact us today and let our experts guide you every step of the way.</p>
          <Link to="/contact-us" className="sa-btn sa-btn-accent">Contact Us</Link>
        </div>
      </div> */}
    </PageLayout>
  );
}
